import { render } from "./BaseSearchIcon.vue?vue&type=template&id=97129512"
const script = {}

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__